import { Application } from "@hotwired/stimulus"
import AutoSubmit from '@stimulus-components/auto-submit'
import Notification from '@stimulus-components/notification'
import { environment } from '../services/environment.js'

const application = Application.start()
application.register('auto-submit', AutoSubmit)
application.register('notification', Notification)


application.debug = environment.isDevelopment()
if (environment.isDevelopment()) {
  console.log('🐞 Stimulus debug mode is enabled');
}

window.Stimulus   = application

export { application }
